import Heading, {HEADING_TYPES} from '@frontend/ui-kit/Components/Heading';
import ContentSection from '@frontend/ui-kit/Components/ContentSection';
import Text from '@frontend/ui-kit/Components/Text';
import LanguageSelector from '../../shared/LanguageSelector';
import AppDownloadSources from '../../shared/AppDownloadSources';
import {gettext} from '../../../translationService';
import './index.scss';

const ActivatedContent = () => {
    return (
        <ContentSection className='activated-content'>
            <Heading type={HEADING_TYPES['1']} className='activated-content__title'>
                {gettext('Your account is')}
                &nbsp;
                <span className='activated-content__title-highlight'>{gettext('Active!')}</span>
            </Heading>
            <Text className='activated-content__text'>
                {gettext('Please download the HealthJoy application to continue.')}
            </Text>

            <AppDownloadSources className='activated-content__app-download-sources'/>

            <LanguageSelector className='activated-content__language-selector'/>
        </ContentSection>
    );
};

export {ActivatedContent as TestableActivatedContent};
export default ActivatedContent;
